import React from 'react';
import PropTypes from 'prop-types';
import MorePropTypes from 'airbnb-prop-types';
import { withStyles } from '@material-ui/core';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  children: MorePropTypes.or([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    MorePropTypes.explicitNull,
  ]).isRequired,
};

export function UnstyledConnectWarning({ classes, children }) {
  return (
    <div className={classes.warningContainer}>
      <div data-lookup="connectWarningChildren" className={classes.children}>
        {children}
      </div>
    </div>
  );
}

UnstyledConnectWarning.propTypes = propTypes;

const styles = (theme) => ({
  warningContainer: {
    display: 'flex',
    margin: `${theme.spacing(2)}px 0`,
    borderRadius: `${theme.spacing(0.5)}px`,
    backgroundColor: theme.customColors.khaki,
    padding: `${theme.spacing(1)}px`,
    boxShadow: '4px 5px 5px 0px rgba(216,216,216,1);',

    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  warning: {
    color: theme.customColors.magenta,
  },
  children: {
    width: '100%',
    '& p, & h6': {
      margin: `${theme.spacing(0.5)}px`,
    },
  },
});

export default withStyles(styles)(UnstyledConnectWarning);
